import { getUrlStatic } from './placeholders-football';

export type PlaceholderMotorsportsType =
  | 'CircuitTrack'
  | 'DriverAvatar'
  | 'DriverFlag'
  | 'GpFlag'
  | 'TeamLogo'
  | 'CircuitTrackWhite';

export const CIRCUITTRACK: PlaceholderMotorsportsType = 'CircuitTrack';
export const CIRCUITTRACKWHITE: PlaceholderMotorsportsType = 'CircuitTrackWhite';
export const DRIVERAVATAR: PlaceholderMotorsportsType = 'DriverAvatar';
export const DRIVERFLAG: PlaceholderMotorsportsType = 'DriverFlag';
export const GPFLAG: PlaceholderMotorsportsType = 'GpFlag';
export const TEAMLOGO: PlaceholderMotorsportsType = 'TeamLogo';

export const placeholdersMap: {
  [key in PlaceholderMotorsportsType]: string;
} = {
  [CIRCUITTRACK]: `https://${getUrlStatic()}/images/skysport/configurations/placeholders/motorsports/circuit-track.svg`,
  [CIRCUITTRACKWHITE]: `https://${getUrlStatic()}/images/skysport/configurations/placeholders/motorsports/circuit-track-white.svg`,
  [DRIVERAVATAR]: `https://${getUrlStatic()}/images/skysport/configurations/placeholders/motorsports/driver-avatar.png`,
  [DRIVERFLAG]: `https://${getUrlStatic()}/images/skysport/configurations/placeholders/motorsports/driver-flag.png`,
  [GPFLAG]: `https://${getUrlStatic()}/images/skysport/configurations/placeholders/motorsports/gp-flag.png`,
  [TEAMLOGO]: `https://${getUrlStatic()}/images/skysport/configurations/placeholders/motorsports/team-logo.png`,
};
